import styled from "styled-components/macro";
import { typography } from "@joor/design-system";

export const Subtitle1 = styled.div`
  flex: 0 0 100%;
  ${typography.alpha.primaryInactive.subtitle1}
  padding-bottom: 1em;
`;
